var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { MEDIA_QUERY_MOBILE } from '../../../constants/media';
import styled from 'styled-components';
import Uppy from '@uppy/core';
import Tus from '@uppy/tus';
import { Endpoints } from '@brg/api';
import FileInput from '@uppy/file-input';
import { ADD_LR_POST_TIMEOUT_END, ADD_LR_POST_TIMEOUT_START, addLongReadPost } from '../../../actions/addLongReadPost';
import Banksy from "../../../images/input_placeholders/Banksy.svg";
import Bosch from "../../../images/input_placeholders/Bosch.svg";
import Cattelan from "../../../images/input_placeholders/Cattelan.svg";
import Dalí from "../../../images/input_placeholders/Dalí.svg";
import Duchamp from "../../../images/input_placeholders/Duchamp.svg";
import Hearst from "../../../images/input_placeholders/Hearst.svg";
import Koons from "../../../images/input_placeholders/Koons.svg";
import useLocalization from '../../../hooks/useLocalization';
import { useToasts } from "@brg/ui";
import { LoaderModal } from '../../modals/LoaderModal';
import { getLongReadPosts } from "../../../actions/getLongReadPosts";
import { getCurrentLongread } from "../../../reducers/longreadBlocks";
import useCommonProps from "../../../hooks/useCommonProps";
import { useGeneralProps } from '../../../hooks/useGeneralProps';
// const INPUT_PLACEHOLDERS = [
//   require("../../../images/input_placeholders/Banksy.svg").default,
//   require("../../../images/input_placeholders/Bosch.svg").default,
//   require("../../../images/input_placeholders/Cattelan.svg").default,
//   require("../../../images/input_placeholders/Dalí.svg").default,
//   require("../../../images/input_placeholders/Duchamp.svg").default,
//   require("../../../images/input_placeholders/Hearst.svg").default,
//   require("../../../images/input_placeholders/Koons.svg").default
// ]
var INPUT_PLACEHOLDERS = [
    Banksy,
    Bosch,
    Cattelan,
    Dalí,
    Duchamp,
    Hearst,
    Koons
];
var PlaceholderIcon = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 72px;\n  width: 72px;\n  background: url(", ") no-repeat center;\n  background-size: contain;\n"], ["\n  height: 72px;\n  width: 72px;\n  background: url(", ") no-repeat center;\n  background-size: contain;\n"])), function (p) { return p.src; });
export var MobileLoaderWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  height: 315px;\n  max-height: 315px;\n  margin-top: 24px;\n\n  .loader-wrapper {\n    background-color: rgba(0,0,0,0.6);\n  }\n\n  img {\n    width: 100%;\n    height: 315px;\n    object-fit: cover;\n  }\n\n"], ["\n  position: relative;\n  width: 100%;\n  height: 315px;\n  max-height: 315px;\n  margin-top: 24px;\n\n  .loader-wrapper {\n    background-color: rgba(0,0,0,0.6);\n  }\n\n  img {\n    width: 100%;\n    height: 315px;\n    object-fit: cover;\n  }\n\n"])));
var AddImageBlockRoot = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 17px;\n  line-height: 22px;\n  margin-top: 24px;\n  background: ", ";\n  display: none;\n  height: 240px;\n\n  input {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    display: block !important;\n    opacity: 0;\n    z-index: 1;\n    cursor: pointer;\n  }\n\n  @media (max-width: ", "px) {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n  }\n"], ["\n  position: relative;\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 17px;\n  line-height: 22px;\n  margin-top: 24px;\n  background: ", ";\n  display: none;\n  height: 240px;\n\n  input {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    display: block !important;\n    opacity: 0;\n    z-index: 1;\n    cursor: pointer;\n  }\n\n  @media (max-width: ", "px) {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n  }\n"])), function (p) { return (p === null || p === void 0 ? void 0 : p.colorStyle) === "dark" ? "#212120" : (p === null || p === void 0 ? void 0 : p.colorStyle) === 'grey' ? '#3F4548' : '#f2f2f2'; }, MEDIA_QUERY_MOBILE);
var PreformattedText = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  white-space: break-spaces;\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  text-align: center;\n  color: #909090;\n"], ["\n  white-space: break-spaces;\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  text-align: center;\n  color: #909090;\n"])));
function AddImageBlock(props) {
    var lgid = props.lgid, lang = props.lang, colorStyle = props.colorStyle, bookId = props.bookId;
    var dispatch = useDispatch();
    var _a = useState(''), imageId = _a[0], setImageId = _a[1];
    var _b = useState(''), bigImageSrc = _b[0], setBigImageSrc = _b[1];
    var currentStore = useSelector(function (store) { return getCurrentLongread(store, lgid); });
    var blocks = currentStore.blocks;
    var test = useSelector(function (state) { return state; });
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var userid = localStorage.getItem('userId');
    var bigimageRef = useRef(null);
    var sign = useCommonProps().sign;
    var generalProps = useGeneralProps();
    var toasts = useToasts();
    var t = useLocalization().t;
    var isBlockLoading = useMemo(function () { return (blocks === null || blocks === void 0 ? void 0 : blocks.some(function (_a) {
        var postId = _a.postId;
        return postId === 'loading';
    })); }, [blocks]);
    var showLoader = useMemo(function () { return ((isLoading /*|| isBlockLoading*/) && bigImageSrc !== ''); }, [isLoading, bigImageSrc, isBlockLoading]);
    var uppy = new Uppy({
        restrictions: { maxNumberOfFiles: 1 },
        allowMultipleUploads: true,
        meta: { type: 'image/jpeg' },
        autoProceed: true,
        onBeforeUpload: function (files) {
            setIsLoading(true);
        }
    })
        .use(Tus, {
        endpoint: "".concat(Endpoints.uploader, "/upload/"),
        chunkSize: 4194304
    })
        .use(FileInput, {
        target: bigimageRef.current,
        id: 'bigimage',
        pretty: true,
        inputName: 'files[]',
        locale: {}
    });
    var savePost = function () {
        dispatch(addLongReadPost({
            id: userid,
            title: '',
            text: '',
            color: 'white',
            imageid: imageId,
            lgid: lgid,
            isFL: false,
            imgCaption: '',
            style: 'image',
            num: blocks.length,
            imageData: bigImageSrc,
            generalProps: generalProps
        }));
        setIsLoading(true);
        dispatch({
            type: ADD_LR_POST_TIMEOUT_START,
            payload: { lgId: lgid, data: [{
                        postId: 'loading',
                        userId: '',
                        longreadId: lgid,
                        style: 'image',
                        isFirstLetter: false,
                        title: '',
                        titlePosition: '',
                        text: '',
                        localization: null,
                        color: '',
                        isHidden: true,
                        isDeleted: true,
                        attachments: [
                            {
                                postAttachmentId: '',
                                type: 0,
                                referenceId: '',
                                text: 'string',
                                description: '',
                                texts: null,
                                descriptions: null,
                                isDeleted: true,
                                file: {
                                    fileId: 'loading',
                                    containerId: null,
                                    isDeleted: false,
                                    isNew: false,
                                    inProgress: false,
                                    type: 'cardimages',
                                    url: bigImageSrc,
                                    size: null,
                                    crop: null,
                                    localization: 'global'
                                }
                            }
                        ],
                        dateCreate: null,
                        dateLastChange: null,
                        like: 0,
                        position: (blocks === null || blocks === void 0 ? void 0 : blocks.length) - 1,
                        leagueItem: null,
                        citiesBlock: null,
                        orderList: null,
                        historyList: null,
                        geozoneBlock: null,
                        specBlock: null
                    }] }
        });
        setIsLoading(false);
        setTimeout(function () {
            dispatch({
                type: ADD_LR_POST_TIMEOUT_END,
                payload: {
                    data: null,
                    lgId: lgid
                }
            });
        }, 5000);
        setTimeout(function () {
            props.getLongReadPosts(userid, lgid, sign);
        }, 5100);
    };
    uppy.on('complete', function (result) {
        try {
            var url = result.successful[0].uploadURL;
            var linkT = url.split('/');
            var lngh = linkT.length - 1;
            var id = linkT[lngh];
            setImageId(id);
        }
        catch (e) {
            console.error(e);
        }
    });
    var addFile = function (event, style, droppedFiles) {
        // добавление и отображение добавленной картинки
        var _a;
        var files;
        // console.log(Array.from(event.target.files))
        if (event === null) {
            files = droppedFiles;
        }
        else {
            files = Array.from(event.target.files);
        }
        if (files.length === 1) {
            var fr_1 = new window.FileReader();
            uppy.reset();
            if (!['image/jpeg', 'image/gif'].includes((_a = files === null || files === void 0 ? void 0 : files[0]) === null || _a === void 0 ? void 0 : _a.type)) {
                toasts.error('Допустимые форматы: jpg, gif');
                return;
            }
            files.forEach(function (file) {
                try {
                    uppy.addFile({
                        source: 'file input',
                        name: file.name,
                        type: file.type || 'application/octet-stream',
                        data: file,
                        meta: {
                            contentType: file.type || 'application/octet-stream'
                        }
                    });
                }
                catch (err) {
                    if (err.isRestriction) {
                        // handle restrictions
                        console.error('Restriction error:', err);
                    }
                    else {
                        // handle other errors
                        console.error(err);
                    }
                }
                fr_1.onload = function () {
                    if (style === 'big' || style === 'image') {
                        // console.log(fr.result);
                        setBigImageSrc(fr_1.result);
                    }
                };
                fr_1.readAsDataURL(files[0]);
            });
        }
    };
    useEffect(function () {
        if (imageId) {
            savePost();
        }
    }, [imageId]);
    var placeholder = useMemo(function () {
        return INPUT_PLACEHOLDERS[Math.floor(Math.random() * INPUT_PLACEHOLDERS.length)];
    }, []);
    if (showLoader) {
        return (React.createElement(MobileLoaderWrapper, { colorStyle: colorStyle },
            React.createElement("img", { src: bigImageSrc, alt: 'image' }),
            React.createElement(LoaderModal, { placeholder: t('modal.loader.isLoading') })));
    }
    return (React.createElement(AddImageBlockRoot, { colorStyle: colorStyle, className: "add-image-block-root" },
        React.createElement("input", { type: 'file', accept: "image/jpeg, image/gif, image/png", ref: bigimageRef, onChange: function (e) { return addFile(e, 'image'); } }),
        React.createElement(PreformattedText, { className: "add-image-block-preformatted-text" }, t('editor.default_img_text'))));
}
var mapStateToProps = function (store) {
    return {};
};
var mapDispatchToProps = function (dispatch) {
    return {
        getLongReadPosts: function (idUser, isLongRead, sign, thematic) {
            return dispatch(getLongReadPosts(idUser, isLongRead, sign, thematic));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddImageBlock);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=addimageblock.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { MEDIA_QUERY_MOBILE } from '../../../constants/media';
import styled from 'styled-components';
import Uppy from '@uppy/core';
import Tus from '@uppy/tus';
import { Endpoints } from '@brg/api';
import FileInput from '@uppy/file-input';
import { ADD_LR_POST_TIMEOUT_END, ADD_LR_POST_TIMEOUT_START, addLongReadPost } from '../../../actions/addLongReadPost';
import Banksy from "../../../images/input_placeholders/Banksy.svg";
import Bosch from "../../../images/input_placeholders/Bosch.svg";
import Cattelan from "../../../images/input_placeholders/Cattelan.svg";
import Dalí from "../../../images/input_placeholders/Dalí.svg";
import Duchamp from "../../../images/input_placeholders/Duchamp.svg";
import Hearst from "../../../images/input_placeholders/Hearst.svg";
import Koons from "../../../images/input_placeholders/Koons.svg";
import useLocalization from '../../../hooks/useLocalization';
import { useToasts } from "@brg/ui";
import { LoaderModal } from '../../modals/LoaderModal';
import { getLongReadPosts } from "../../../actions/getLongReadPosts";
import { getCurrentLongread } from "../../../reducers/longreadBlocks";
import useCommonProps from "../../../hooks/useCommonProps";
import { useGeneralProps } from '../../../hooks/useGeneralProps';
// const INPUT_PLACEHOLDERS = [
//   require("../../../images/input_placeholders/Banksy.svg").default,
//   require("../../../images/input_placeholders/Bosch.svg").default,
//   require("../../../images/input_placeholders/Cattelan.svg").default,
//   require("../../../images/input_placeholders/Dalí.svg").default,
//   require("../../../images/input_placeholders/Duchamp.svg").default,
//   require("../../../images/input_placeholders/Hearst.svg").default,
//   require("../../../images/input_placeholders/Koons.svg").default
// ]
var INPUT_PLACEHOLDERS = [
    Banksy,
    Bosch,
    Cattelan,
    Dalí,
    Duchamp,
    Hearst,
    Koons
];
var PlaceholderIcon = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 72px;\n  width: 72px;\n  background: url(", ") no-repeat center;\n  background-size: contain;\n"], ["\n  height: 72px;\n  width: 72px;\n  background: url(", ") no-repeat center;\n  background-size: contain;\n"])), function (p) { return p.src; });
export var MobileLoaderWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  height: 315px;\n  max-height: 315px;\n  margin-top: 24px;\n\n  .loader-wrapper {\n    background-color: rgba(0,0,0,0.6);\n  }\n\n  img {\n    width: 100%;\n    height: 315px;\n    object-fit: cover;\n  }\n\n"], ["\n  position: relative;\n  width: 100%;\n  height: 315px;\n  max-height: 315px;\n  margin-top: 24px;\n\n  .loader-wrapper {\n    background-color: rgba(0,0,0,0.6);\n  }\n\n  img {\n    width: 100%;\n    height: 315px;\n    object-fit: cover;\n  }\n\n"])));
var AddImageBlockRoot = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 17px;\n  line-height: 22px;\n  margin-top: 24px;\n  background: ", ";\n  display: none;\n  height: 240px;\n\n  input {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    display: block !important;\n    opacity: 0;\n    z-index: 1;\n    cursor: pointer;\n  }\n\n  @media (max-width: ", "px) {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n  }\n"], ["\n  position: relative;\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 17px;\n  line-height: 22px;\n  margin-top: 24px;\n  background: ", ";\n  display: none;\n  height: 240px;\n\n  input {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    display: block !important;\n    opacity: 0;\n    z-index: 1;\n    cursor: pointer;\n  }\n\n  @media (max-width: ", "px) {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n  }\n"])), function (p) { return (p === null || p === void 0 ? void 0 : p.colorStyle) === "dark" ? "#212120" : (p === null || p === void 0 ? void 0 : p.colorStyle) === 'grey' ? '#3F4548' : '#f2f2f2'; }, MEDIA_QUERY_MOBILE);
var PreformattedText = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  white-space: break-spaces;\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  text-align: center;\n  color: #909090;\n"], ["\n  white-space: break-spaces;\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  text-align: center;\n  color: #909090;\n"])));
function AddImageBlock(props) {
    var lgid = props.lgid, lang = props.lang, colorStyle = props.colorStyle, bookId = props.bookId;
    var dispatch = useDispatch();
    var _a = useState(''), imageId = _a[0], setImageId = _a[1];
    var _b = useState(''), bigImageSrc = _b[0], setBigImageSrc = _b[1];
    var currentStore = useSelector(function (store) { return getCurrentLongread(store, lgid); });
    var blocks = currentStore.blocks;
    var test = useSelector(function (state) { return state; });
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var userid = localStorage.getItem('userId');
    var bigimageRef = useRef(null);
    var sign = useCommonProps().sign;
    var generalProps = useGeneralProps();
    var toasts = useToasts();
    var t = useLocalization().t;
    var isBlockLoading = useMemo(function () { return (blocks === null || blocks === void 0 ? void 0 : blocks.some(function (_a) {
        var postId = _a.postId;
        return postId === 'loading';
    })); }, [blocks]);
    var showLoader = useMemo(function () { return ((isLoading /*|| isBlockLoading*/) && bigImageSrc !== ''); }, [isLoading, bigImageSrc, isBlockLoading]);
    var uppy = new Uppy({
        restrictions: { maxNumberOfFiles: 1 },
        allowMultipleUploads: true,
        meta: { type: 'image/jpeg' },
        autoProceed: true,
        onBeforeUpload: function (files) {
            setIsLoading(true);
        }
    })
        .use(Tus, {
        endpoint: "".concat(Endpoints.uploader, "/upload/"),
        chunkSize: 4194304
    })
        .use(FileInput, {
        target: bigimageRef.current,
        id: 'bigimage',
        pretty: true,
        inputName: 'files[]',
        locale: {}
    });
    var savePost = function () {
        dispatch(addLongReadPost({
            id: userid,
            title: '',
            text: '',
            color: 'white',
            imageid: imageId,
            lgid: lgid,
            isFL: false,
            imgCaption: '',
            style: 'image',
            num: blocks.length,
            imageData: bigImageSrc,
            generalProps: generalProps
        }));
        setIsLoading(true);
        dispatch({
            type: ADD_LR_POST_TIMEOUT_START,
            payload: { lgId: lgid, data: [{
                        postId: 'loading',
                        userId: '',
                        longreadId: lgid,
                        style: 'image',
                        isFirstLetter: false,
                        title: '',
                        titlePosition: '',
                        text: '',
                        localization: null,
                        color: '',
                        isHidden: true,
                        isDeleted: true,
                        attachments: [
                            {
                                postAttachmentId: '',
                                type: 0,
                                referenceId: '',
                                text: 'string',
                                description: '',
                                texts: null,
                                descriptions: null,
                                isDeleted: true,
                                file: {
                                    fileId: 'loading',
                                    containerId: null,
                                    isDeleted: false,
                                    isNew: false,
                                    inProgress: false,
                                    type: 'cardimages',
                                    url: bigImageSrc,
                                    size: null,
                                    crop: null,
                                    localization: 'global'
                                }
                            }
                        ],
                        dateCreate: null,
                        dateLastChange: null,
                        like: 0,
                        position: (blocks === null || blocks === void 0 ? void 0 : blocks.length) - 1,
                        leagueItem: null,
                        citiesBlock: null,
                        orderList: null,
                        historyList: null,
                        geozoneBlock: null,
                        specBlock: null
                    }] }
        });
        setIsLoading(false);
        setTimeout(function () {
            dispatch({
                type: ADD_LR_POST_TIMEOUT_END,
                payload: {
                    data: null,
                    lgId: lgid
                }
            });
        }, 5000);
        setTimeout(function () {
            props.getLongReadPosts(userid, lgid, sign);
        }, 5100);
    };
    uppy.on('complete', function (result) {
        try {
            var url = result.successful[0].uploadURL;
            var linkT = url.split('/');
            var lngh = linkT.length - 1;
            var id = linkT[lngh];
            setImageId(id);
        }
        catch (e) {
            console.error(e);
        }
    });
    var addFile = function (event, style, droppedFiles) {
        // добавление и отображение добавленной картинки
        var _a;
        var files;
        // console.log(Array.from(event.target.files))
        if (event === null) {
            files = droppedFiles;
        }
        else {
            files = Array.from(event.target.files);
        }
        if (files.length === 1) {
            var fr_1 = new window.FileReader();
            uppy.reset();
            if (!['image/jpeg', 'image/gif'].includes((_a = files === null || files === void 0 ? void 0 : files[0]) === null || _a === void 0 ? void 0 : _a.type)) {
                toasts.error('Допустимые форматы: jpg, gif');
                return;
            }
            files.forEach(function (file) {
                try {
                    uppy.addFile({
                        source: 'file input',
                        name: file.name,
                        type: file.type || 'application/octet-stream',
                        data: file,
                        meta: {
                            contentType: file.type || 'application/octet-stream'
                        }
                    });
                }
                catch (err) {
                    if (err.isRestriction) {
                        // handle restrictions
                        console.error('Restriction error:', err);
                    }
                    else {
                        // handle other errors
                        console.error(err);
                    }
                }
                fr_1.onload = function () {
                    if (style === 'big' || style === 'image') {
                        // console.log(fr.result);
                        setBigImageSrc(fr_1.result);
                    }
                };
                fr_1.readAsDataURL(files[0]);
            });
        }
    };
    useEffect(function () {
        if (imageId) {
            savePost();
        }
    }, [imageId]);
    var placeholder = useMemo(function () {
        return INPUT_PLACEHOLDERS[Math.floor(Math.random() * INPUT_PLACEHOLDERS.length)];
    }, []);
    if (showLoader) {
        return (React.createElement(MobileLoaderWrapper, { colorStyle: colorStyle },
            React.createElement("img", { src: bigImageSrc, alt: 'image' }),
            React.createElement(LoaderModal, { placeholder: t('modal.loader.isLoading') })));
    }
    return (React.createElement(AddImageBlockRoot, { colorStyle: colorStyle, className: "add-image-block-root" },
        React.createElement("input", { type: 'file', accept: "image/jpeg, image/gif, image/png", ref: bigimageRef, onChange: function (e) { return addFile(e, 'image'); } }),
        React.createElement(PreformattedText, { className: "add-image-block-preformatted-text" }, t('editor.default_img_text'))));
}
var mapStateToProps = function (store) {
    return {};
};
var mapDispatchToProps = function (dispatch) {
    return {
        getLongReadPosts: function (idUser, isLongRead, sign, thematic) {
            return dispatch(getLongReadPosts(idUser, isLongRead, sign, thematic));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddImageBlock);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=addimageblock.js.map